

export const larryBio = {
  _id: 'larryBioId',
  userId: 'larryUserId',
  email: 'larry@email.com',
  aboutMe: [
    `Self-loathing bald man but too proud for toupés`,
    `Bald asshole and four-eyed fuck`,
    `Champion middler at dinner parties`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who respects wood`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Full elasticity on the sleeves of my long-sleeve shirts`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Would you donate a kidney to your best friend if the blood types matched?`,
    }
  ],
  hobbies: [
    `Golf`,
    `Avoiding People`,
    `Comedy`,
    `Vendettas`,
    `Anonymous Donations`
  ],
  vitalInfo: {
    firstName: `Larry`, 
    age: 68,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 75,
    heightCM: 190,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `NYC`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Comedian`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Don't want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const leonBio = {
  _id: 'leonBioId',
  userId: 'leonUserId',
  email: 'leon@email.com',
  aboutMe: [
    `Brings the ruckus to the ladies`,
    `Valedictorian of tappin that ass`,
    `Big Johnson Community manager`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A new Mary Ferguson to join me in a trip through Asia`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Lampin`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Does society esteem black men who wear glasses?`,
    }
  ],
  hobbies: [
    `Lampin`,
    `Watermelon`,
    `Tappin that ass`,
    `Getting mine`,
    `Bringing the ruckus`
  ],
  vitalInfo: {
    firstName: `Leon`, 
    age: 41,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 174,
    heightCM: 192,
    inOrCmPreference: 'in',
    currentCity: `LA`,
    hometown: `Atlanta`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Manager`,
    employer: `Latte Larry's`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Short-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}
